import { render, staticRenderFns } from "./form.view.vue?vue&type=template&id=7287dfe6&scoped=true&lang=pug"
import script from "./form.view.vue?vue&type=script&lang=ts"
export * from "./form.view.vue?vue&type=script&lang=ts"
import style0 from "./form.view.vue?vue&type=style&index=0&id=7287dfe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7287dfe6",
  null
  
)

export default component.exports